import type { Components } from '@mui/material/styles';

export const MuiDivider = (): Partial<Components> => ({
  MuiDivider: {
    styleOverrides: {
      root: {
        height: '1px',
      },
    },
  },
});
